<template>
  <footer class="site-footer">
    <span>© 拼豆物语</span>
    <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
      豫ICP备2025146740号-2
    </a>
  </footer>
</template>

<style scoped>
.site-footer{
  min-height:54px;
  display:flex;
  align-items:center;
  justify-content:center;
  gap:12px;
  color:var(--muted);
  font-size:12px;
}
.site-footer a{color:inherit;text-decoration:none}
.site-footer a:hover{color:var(--brand-dark)}
</style>
